import React from 'react';

function HelplineQuickLinks() {
 const popularServices = [
  { name: 'Magisterials', iconType: 'scale', color: '#0ea5e9', link: 'https://balasore.odisha.gov.in/en/more/citizen-services/magisterials' },
  { name: 'Revenue', iconType: 'chart', color: '#0ea5e9', link: 'https://bhulekh.ori.nic.in/' },
  { name: 'Bills', iconType: 'document', color: '#0ea5e9', link: 'https://balasore.odisha.gov.in/en/more/citizen-services/bills' },
  { name: 'Certificates', iconType: 'certificate', color: '#0ea5e9', link: 'https://balasore.odisha.gov.in/en/more/citizen-services/certificates' },
  { name: 'SAMS', iconType: 'mail', color: '#0ea5e9', link: 'https://samsodisha.gov.in' },
  { name: 'EDistrict', iconType: 'user-group', color: '#0ea5e9', link: 'https://edistrict.odisha.gov.in' },
  { name: 'GoSugam', iconType: 'car', color: '#0ea5e9', link: 'https://sugam.odisha.gov.in/website/home' },
  // { name: 'BASUDHA', iconType: 'globe', color: '#0ea5e9', link: 'https://basudha.odisha.gov.in' }
];


  const publicInfo = [
    { label: 'PC', value: '6', icon: '🏛️' },
    { label: 'Garmya Panchayat', value: '37', icon: '🏘️' },
    { label: 'Police Station', value: '24', icon: '👮' },
    { label: 'ULBs List', value: '5', icon: '🏙️' },
    { label: 'Villages', value: '3049', icon: '🏡' },
    { label: 'Blocks', value: '12', icon: '📍' },
    { label: 'Tahasils', value: '12', icon: '🏢' },
    { label: 'Population', value: '2317419', icon: '👥' }
  ];

  const helplineData = [
    { category: 'Covid Helpline', numbers: ['104 & 06724-221016'] },
    { category: 'District Emergency Helpline', numbers: ['06724-220368/1077'] },
    { category: 'Citizen\'s Call Center', numbers: ['155300'] },
    { category: 'Child Helpline', numbers: ['1098'] },
    { category: 'Women Helpline', numbers: ['1091'] },
    { category: 'Crime Stopper', numbers: ['1090'] },
    { category: 'Helpline for Women in Distress', numbers: ['7827170170'] }
  ];

  const quickLinks = [
    { name: 'Public Utilities', url: 'https://balasore.odisha.gov.in/public-utilities-page' },
    { name: 'Census', url: 'https://censusindia.gov.in/census.website/' },
    { name: 'CAP National Disaster Alert Portal', url: 'https://sachet.ndma.gov.in/' },
    { name: 'Odisha Birth & Death Registration System', url: 'https://www.birthdeath.odisha.gov.in/' },
    { name: 'Chief Electoral Officer, Odisha', url: 'https://ceoodisha.nic.in/' },
    { name: 'Right to Information Act', url: 'https://rtiodisha.gov.in/' },
    { name: 'Aadhaar', url: 'https://uidai.gov.in/' },
    { name: 'Odisha One Unified Citizen Portal', url: 'https://www.odishaone.gov.in/citizen/' },
    { name: 'Public Grievance', url: 'https://janasunani.odisha.gov.in/' }
  ];

  const renderIcon = (iconType) => {
    const iconProps = {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "white"
    };

    switch(iconType) {
      case 'scale':
        return (
          <svg {...iconProps}>
            <path d="M12 2C10.9 2 10 2.9 10 4H8C6.9 4 6 4.9 6 6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-2c0-1.1-.9-2-2-2zm0 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"/>
          </svg>
        );
      case 'chart':
        return (
          <svg {...iconProps}>
            <path d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"/>
          </svg>
        );
      case 'document':
        return (
          <svg {...iconProps}>
            <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
          </svg>
        );
      case 'certificate':
        return (
          <svg {...iconProps}>
            <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H5V9h14v2zm-4 4H5v-2h10v2zm4-8H5V5h14v2z"/>
          </svg>
        );
      case 'mail':
        return (
          <svg {...iconProps}>
            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
        );
      case 'user-group':
        return (
          <svg {...iconProps}>
            <path d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
          </svg>
        );
      case 'car':
        return (
          <svg {...iconProps}>
            <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
          </svg>
        );
      case 'globe':
        return (
          <svg {...iconProps}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  const scrollServices = (direction) => {
    const container = document.getElementById('services-container');
    if (container) {
      const scrollAmount = 250;
      if (direction === 'left') {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="helpline-container">
      {/* Popular Services Section */}
      <div className="services-section">
        <div className="services-wrapper">
          <div className="services-content">
            <div className="services-label">Popular Services</div>

            <button className="scroll-btn" onClick={() => scrollServices('left')}>◀</button>

            <div id="services-container" className="services-scroll">
  {popularServices.map((service, index) => {
    const isExternal = service.link.startsWith('http');

    return (
      <a
        key={index}
        href={service.link}
        target={isExternal ? '_blank' : '_self'}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        className="service-link"
      >
        <div className="service-card">
          <div className="service-icon">
            {renderIcon(service.iconType)}
          </div>
          <span className="service-name">{service.name}</span>
        </div>
      </a>
    );
  })}
</div>


            <button className="scroll-btn" onClick={() => scrollServices('right')}>▶</button>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="main-content">
        <div className="content-wrapper">
          <div className="content-grid">
            {/* Helpline Section */}
            <div className="section-card">
              <h2 className="section-title">Helpline</h2>
              <div className="helpline-list">
                {helplineData.map((item, index) => (
                  <div key={index} className="helpline-item">
                    <div className="helpline-category">{item.category}</div>
                    {item.numbers.map((number, idx) => (
                      <div key={idx} className="helpline-number">{number}</div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Links Section */}
            <div className="section-card">
              <h2 className="section-title">Quick Links</h2>
              <div className="links-list">
                {quickLinks.map((link, index) => (
                  <a key={index} href={link.url} className="link-item" target="_blank" rel="noopener noreferrer">
                    <span className="link-icon">→</span>
                    <span className="link-text">{link.name}</span>
                    <span className="link-arrow">→</span>
                  </a>
                ))}
              </div>
              <div className="view-more-wrapper">
                <button className="view-more-btn">VIEW MORE →</button>
              </div>
            </div>

            {/* Public Information Section */}
            <div className="section-card public-info">
              <h2 className="section-title">Public Information</h2>
              <div className="info-grid">
                {publicInfo.map((info, index) => (
                  <div key={index} className="info-card">
                    <div className="info-value">{info.value}</div>
                    <div className="info-label">{info.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .helpline-container {
          font-family: Arial, sans-serif;
          background: linear-gradient(180deg, #f5f5f5 0%, #e0e0e0 100%);
          height: 100%;
        }

        /* Services Section */
        .services-section {
          background: white;
          padding: 15px 10px;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
          margin-bottom: 20px;
        }

        .services-wrapper {
          max-width: 1200px;
          margin: 0 auto;
        }

        .services-content {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .services-label {
          background: linear-gradient(135deg, #4dd0e1 0%, #00bcd4 100%);
          color: white;
          padding: 10px 20px;
          font-size: 14px;
          font-weight: 600;
          clip-path: polygon(0 0, 100% 0, 95% 100%, 0% 100%);
          min-width: 160px;
          text-align: center;
          box-shadow: 0 2px 6px rgba(0, 188, 212, 0.3);
        }

        .scroll-btn {
          background: #003366;
          color: white;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .scroll-btn:hover {
          background: #00509e;
        }

        .services-scroll {
          display: flex;
          gap: 10px;
          overflow-x: auto;
          scroll-behavior: smooth;
          flex: 1;
          padding: 5px 0;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        

        .services-scroll::-webkit-scrollbar {
          display: none;
        }

        .service-card {
          background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
          color: white;
          padding: 12px 20px;
          border-radius: 8px;
          min-width: 140px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 2px 6px rgba(14, 165, 233, 0.3);
          display: flex;
          align-items: center;
          gap: 8px;
          flex-shrink: 0;
        }

        .service-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
        }
          .service-link {
  text-decoration: none;
  color: inherit;
}
.service-link:hover {
  text-decoration: none;
}


        .service-icon {
          background: rgba(255, 255, 255, 0.2);
          width: 35px;
          height: 35px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .service-name {
          font-size: 13px;
          font-weight: 600;
        }

        /* Main Content */
        .main-content {
          background: linear-gradient(180deg, #0a2540 0%, #1a4d73 100%);
          padding: 20px 15px;
        }

        .content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
        }

        .content-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 15px;
          align-items: stretch;
        }

        .section-card {
          background: white;
          border-radius: 8px;
          padding: 15px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          display: flex;
          flex-direction: column;
          height: 400px;
        }

        .section-title {
          color: #003366;
          font-size: 18px;
          font-weight: 700;
          margin: 0 0 15px 0;
          border-bottom: 2px solid #003366;
          padding-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* Helpline */
        .helpline-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
          overflow-y: auto;
          flex: 1;
        }

        .helpline-item {
          border-left: 3px solid #00509e;
          padding-left: 10px;
          padding-bottom: 8px;
          border-bottom: 1px solid #e0e0e0;
        }

        .helpline-item:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .helpline-category {
          color: #666;
          font-size: 13px;
          margin-bottom: 4px;
          font-weight: 600;
          text-transform: capitalize;
        }

        .helpline-number {
          color: #003366;
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 0.5px;
        }

        /* Quick Links */
        .links-list {
          display: flex;
          flex-direction: column;
          max-height: 300px;
          overflow-y: auto;
        }

        .link-item {
          display: flex;
          align-items: center;
          padding: 10px 0;
          color: #333;
          text-decoration: none;
          font-size: 14px;
          border-bottom: 1px solid #e0e0e0;
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .link-item:last-child {
          border-bottom: none;
        }

        .link-item:hover {
          color: #00509e;
          padding-left: 8px;
          text-decoration: none;

        }

        .link-item:hover .link-arrow {
          opacity: 1;
        }

        .link-icon {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #00bcd4;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          color: white;
          font-size: 12px;
          font-weight: 700;
          flex-shrink: 0;
        }

        .link-text {
          flex: 1;
        }

        .link-arrow {
          font-size: 14px;
          color: #00509e;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .view-more-wrapper {
          margin-top: 12px;
          text-align: right;
        }

        .view-more-btn {
          background: #003366;
          color: white;
          border: none;
          padding: 6px 15px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(0, 51, 102, 0.3);
        }

        .view-more-btn:hover {
          background: #00509e;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 51, 102, 0.4);
        }

        /* Public Information */
        .public-info {
          height: auto;
        }

        .info-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
        }

        .info-card {
          background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
          padding: 16px 12px;
          border-radius: 8px;
          text-align: center;
          color: white;
          box-shadow: 0 2px 8px rgba(14, 165, 233, 0.3);
          transition: all 0.3s ease;
        }

        .info-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(14, 165, 233, 0.4);
        }

        .info-value {
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 6px;
          letter-spacing: 0.5px;
        }

        .info-label {
          font-size: 12px;
          font-weight: 600;
          opacity: 0.95;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .content-grid {
            grid-template-columns: 1fr 1fr;
          }

          .public-info {
            grid-column: 1 / -1;
          }

          .info-grid {
            grid-template-columns: repeat(4, 1fr);
          }
          
          .info-value {
            font-size: 22px;
          }
          
          .info-label {
            font-size: 11px;
          }
        }

        @media (max-width: 768px) {
          .content-grid {
            grid-template-columns: 1fr;
            gap: 12px;
          }

          .public-info {
            grid-column: 1;
          }

          .info-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 8px;
          }

          .services-label {
            font-size: 12px;
            padding: 8px 15px;
            min-width: 130px;
          }

          .service-card {
            min-width: 120px;
            padding: 10px 15px;
          }

          .service-icon {
            width: 30px;
            height: 30px;
          }

          .service-name {
            font-size: 12px;
          }
          
          .section-card {
            padding: 12px;
          }
          
          .section-title {
            font-size: 16px;
            margin-bottom: 12px;
          }
          
          .helpline-number {
            font-size: 15px;
          }
          
          .link-item {
            font-size: 13px;
            padding: 8px 0;
          }
          
          .info-value {
            font-size: 20px;
          }
          
          .info-label {
            font-size: 11px;
          }
          
          .info-card {
            padding: 14px 10px;
          }
        }

        @media (max-width: 480px) {
          .services-label {
            font-size: 11px;
            padding: 6px 12px;
            min-width: 110px;
          }

          .scroll-btn {
            width: 28px;
            height: 28px;
            font-size: 14px;
          }

          .service-card {
            min-width: 100px;
            padding: 8px 12px;
          }

          .section-title {
            font-size: 15px;
          }

          .info-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .info-value {
            font-size: 22px;
          }

          .info-label {
            font-size: 11px;
          }

          .section-card {
            padding: 10px;
          }
          
          .helpline-category {
            font-size: 12px;
          }
          
          .helpline-number {
            font-size: 14px;
          }
          
          .link-item {
            font-size: 12px;
            padding: 7px 0;
          }
          
          .link-icon {
            width: 18px;
            height: 18px;
            font-size: 11px;
          }
          
          .main-content {
            padding: 15px 10px;
          }
        }
      `}</style>
    </div>
  );
}

export default HelplineQuickLinks;